module.exports = __webpack_public_path__ + "img/1F55F.2646f571.svg";